import {
	agreementsTableHeaderActionsState,
	casesTableHeaderActionsState,
	documentsTableHeaderActionsState,
	formsTableHeaderActionsState,
	publicAgreementsTableHeaderActionsState,
	recordsTableHeaderActionsState,
	refundsTableHeaderActionsState,
	simulationsTableHeaderActionsState,
} from "../../../store/lyfe-data-table";
import { TableTypes } from "../LyfeDataTable";

export default function getTableState(type: TableTypes) {
	switch (type) {
		case "forms":
			return formsTableHeaderActionsState;
		case "records":
			return recordsTableHeaderActionsState;
		case "cases":
			return casesTableHeaderActionsState;
		case "agreements":
			return agreementsTableHeaderActionsState;
		case "publicAgreements":
			return publicAgreementsTableHeaderActionsState;
		case "transactions":
			return refundsTableHeaderActionsState;
		case "documents":
			return documentsTableHeaderActionsState;
		case "simulations":
			return simulationsTableHeaderActionsState;
		default:
			throw new Error("Unknown table. Couldn't get Table Header Action State");
	}
}
